import { getRequest, postRequest } from "app/axiosClient";
import { getStageRecords, resetState } from "./StageSlice";
import {
  showLoader,
  hideLoader,
} from "../CommonComponents/GlobalSpinner/GlobalSpinnerSlice";
import OpenNotificationWithIcon from "common/utils/OpenNotificationWithIcon";
export const getStageRecordsApi = (noteID) => (dispatch) => {
  try {
    dispatch(showLoader());
    getRequest(`api/Stage/GetStagesList?NoteID=${noteID}`)
      .then((res) => {
        dispatch(getStageRecords(res.data));
        dispatch(hideLoader());
      })
      .catch((e) => {
        dispatch(hideLoader());
        OpenNotificationWithIcon(
          "error",
          "Common.Error",
          "",
          "Visits.Unablefetchdata"
        );
      });
  } catch (e) {
    dispatch(hideLoader());
    OpenNotificationWithIcon(
      "error",
      "Common.Error",
      "",
      "Visits.Unablefetchdata"
    );
  }
};

export const updateStageDetailsApi =
  (values, noteId, setChangedData) => (dispatch) => {
    try {
      dispatch(showLoader());
      postRequest(`api/Stage/UpdateStages`, values)
        .then((res) => {
          dispatch(getStageRecordsApi(noteId));
          dispatch(hideLoader());
          setChangedData([]);
          OpenNotificationWithIcon(
            "success",
            "Common.Success",
            "",
            "Stage.UpdateSuccess"
          );
        })
        .catch((e) => {
          dispatch(hideLoader());
          OpenNotificationWithIcon(
            "error",
            "Common.Error",
            "",
            "Stage.UnabletoUpdate"
          );
        });
    } catch (e) {
      dispatch(hideLoader());
      OpenNotificationWithIcon(
        "error",
        "Common.Error",
        "",
        "Stage.UnabletoUpdate"
      );
    }
  };
export const clearStageStateApi = () => (dispatch) => {
  dispatch(resetState());
};
